import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import { css, cx } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import Header from '../../components/Header';
import InsideHeader from '../../components/InsideHeader';
import Footer from '../../components/Footer';
import PageHelmet from '../../components/PageHelmet';
import CallToAction from '../../components/CallToAction';
import Testimonial from '../../components/Testimonial';
import { colors } from '../../styles';

const styles = css`
  padding: 15vh 10vw;
  @media(min-width: 768px) {
    padding: 18vh 0 15vh;
  }
  @media(min-width: 992px) {
    padding: 10vh 10vw 15vh;
  }
  h3, p {
    text-align: center;
    color: ${colors.brand1};
    @media(min-width: 768px) {
      text-align: left;
    }
  }

  ul li {
    list-style-type: none;

    &::before {
    display: inline-block;
    content: "";
    height: 0.75rem;
    width: 0.75rem;
    margin-right: 0.5rem;
    background-color: rgb(60, 157, 199);
    border-radius: 0.375rem;
    }
  }
`;

function NoRoute({ page }) {
  return (
    <div>
      <PageHelmet page={page} />
      <Header />
      <InsideHeader
        h1={`${page.meta.name}`}
        background={get(page, 'page_image.contentUrl')}
      />
      <div className={cx('container', styles)}>
        <h3>{get(page, 'lead_copy')}</h3>
        <div dangerouslySetInnerHTML={SanitizeHtml(get(page, 'body_copy'))} />
      </div>
      <CallToAction />
      <Testimonial />
      <Footer />
    </div>
  );
}

NoRoute.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'page_not_found',
})(NoRoute);



// WEBPACK FOOTER //
// ./src/pages/NoRoutes/index.js